import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `CopiaSeguridad/realizarCopiaSeguridad`, method: 'POST', body: values, token: token})
}
